import type { FC } from 'react';
import { useMemo } from 'react';
import type { TPlacementHostCompany } from '@shared/types/placement-host-company';
import { cn } from '@src/design-system/helpers';
import HostItem from './components/host-item';

const AddressInformation: FC<{
  host: TPlacementHostCompany;
  modal?: boolean;
}> = ({ host, modal = true }) => {
  const addressInformation = useMemo(() => {
    const base = [
      {
        label: 'Address 1',
        value: host?.address_line_1,
      },
      {
        label: 'Address 2',
        value: host?.address_line_2,
      },
      {
        label: 'City',
        value: host?.city,
      },
      {
        label: 'ZIP/Postal Code',
        value: host?.postal_code,
      },
      {
        label: 'State/Province',
        value: host?.state,
      },
      {
        label: 'Country',
        value: host?.country?.name,
      },
    ];

    if (modal) {
      return base;
    }

    return [
      base[0],
      base[2],
      base[3],
      base[1],
      base[4],
      base[5],
    ];
  }, [host, modal]);

  return (
    <div
      className={cn(
        'space-y-4 p-4 m-4 mt-0 bg-white rounded-xl',
        !modal && 'm-0 p-0'
      )}
    >
      <p className='font-semibold text-gray-800'>Address Information</p>
      <div
        className={cn(
          'grid gap-3',
          modal ? 'grid-cols-1' : 'sm:grid-cols-2 lg:grid-cols-3'
        )}
      >
        {addressInformation.map((item) => (
          <HostItem
            key={item.label}
            label={item.label}
            value={item.value ?? '—'}
          />
        ))}
      </div>
    </div>
  );
};

export default AddressInformation;
